import { CustomerGiftCard } from './gift-card.model';
import {BillingAddress} from './payment-item.model';
import {Currency} from './restaurant.model';

export class Customer {
  constructor(
    public squareCustomerId: string = null,
    public phone: string = null,
    public orderBotUserId: string = null,
    public cards: any = null,
    public givenName: string = null,
    public familyName: string = null,
    public emailAddress: string = null,
    public address: BillingAddress = null,
    public sharedCards: boolean = null,
    public loyaltyPointsBalance: number = 0,
    public loyaltyAccountId: string = null,
    public loyaltyRewardsTier: LoyaltyRewardTier[] = [],
    public isShared: boolean = null,
    public giftCards: CustomerGiftCard[] = [],
    public ikon_pass_id: string = null,
  ) {
  }
}

export class LoyaltyRewardTier {
  constructor(
    public id: string = null,
    public points: number = null,
    public name: string = null,
    public isNamesUpdated: boolean = false,
    public definition: LoyaltyRewardDefinition = new LoyaltyRewardDefinition()
  ) {
  }
}

export class LoyaltyRewardDefinition {
  constructor(
    public catalog_object_ids: string[] = [],
    public discount_type: string = null,
    public fixed_discount_money: number = 0,
    public max_discount_money: number = 0,
    public percentage_discount: string = null,
    public scope: string = null
  ) {
  }
}
export class CustomerData {
  constructor(
    public token: string = null,
    public phone: string = null,
    public orderBotUserId: string = null
  ) {
  }
}

export enum LoyaltyRewardScope {
  ITEM_VARIATION= 'ITEM_VARIATION',
  CATEGORY = 'CATEGORY',
  ORDER = 'ORDER'
}

export class CustomerToken {
  constructor (
    public token: string,
    public customer: Customer
  ) {
  }
}

export enum VerifyState {
  RESENT_CODE = 'resend code',
  CODE_SENT = 'code sent',
  VERIFIED = 'verified',
  SEND_CODE = 'send code',
  VERIFY_PHONE = 'verify phone',
}

export class CustomerFavoriteItemDTO {
  constructor(
    public itemId: string = null
  ) {}
}

export class AtriumInfo {
  constructor(
    public campusId: string = null,
    public token: string = null,
    public balance: number = null,
    public currency: Currency = Currency.USD,
  ) {
  }
}
